import { useHistory } from "react-router-dom";

import HeaderReportMp from "../../../../Components/ComponentsMarketplace/HeaderReportMp";
import ButtonsMap from "../../../../Components/ComponentsMarketplace/ButtonsMap";

import {
  Container,
  SizeContainer,
  InternalMenu,
  RoundContainer,
  H2RoundContainer,
  ParagraphRoundContainer,
  MainRoundContainer,
} from "./style";
import { Tabs } from "react-bootstrap";
import { Tab } from "bootstrap";
import { useEffect, useState } from "react";
import { useUser } from "../../../../providers/UserContext";
import { useReportWeeklyMarket } from "../../../../providers/ReportWeeklyMarket";
import Loading from "../../../../Components/Loading";

const WeeklyReportPurchases = () => {
  const history = useHistory();
  const [key, setKey] = useState('andamento');
  const { marketPlace, jogo } = useUser()
  const { reportWeeklyMarket, loading, fetchReportWeeklyMarket, setReportWeeklyMarket } = useReportWeeklyMarket()

  useEffect(() => {
    setReportWeeklyMarket({
      sales: [],
      purchasesInProgress: [],
      purchasesDone: []
    })
    if (!marketPlace?.supermercado || !jogo?.jogo) return
    fetchReportWeeklyMarket()
  }, [marketPlace, jogo])

  return (
    <Container>
      <SizeContainer>
        <HeaderReportMp title="RELATÓRIOS" pathImg="./images/calendar.svg" />
        <InternalMenu>
          {/* <button onClick={() => history.push("/weeklyReportStock")}>
            <img src="./images/stock_Mp.svg" alt="stock_Mp" />
          </button> */}
          <button className="selected" >
            <img src="./images/purchase_button.svg" alt="purchase_button" />
          </button>
          <button onClick={() => history.push("/weeklyReportSales")}>
            <img src="./images/partnership.svg" alt="partnership" />
          </button>
        </InternalMenu>
        {loading ? (
          <RoundContainer>
            <Loading />
          </RoundContainer>

        ) : null
        }
        <Tabs
          style={{
            position: 'absolute',
            width: '100%',
            top: 180,
            justifyContent: 'center',
            paddingTop: 10,
          }}
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
          fill
        >
          <Tab eventKey="andamento" title="Em andamento">
            {!loading && reportWeeklyMarket?.purchasesInProgress?.length === 0 ? (
              <RoundContainer style={{ justifyContent: 'center' }}>
                <p style={{ fontSize: 20, fontWeight: 'bold' }}>Nenhuma compra.</p>
              </RoundContainer>
            ) : null
            }
            {reportWeeklyMarket?.purchasesInProgress?.map((purchase, index) => {
              return (
                <RoundContainer key={index}>
                  <H2RoundContainer>
                    RODADA {purchase[0]?.rodada?.numero}
                    <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
                  </H2RoundContainer>
                  <ParagraphRoundContainer>
                    Compra de Produtos
                    <div />
                  </ParagraphRoundContainer>
                  <MainRoundContainer>
                    {purchase?.map((item, index) => {
                      let imageURL = null
                      if (item?.itemCompra[0].produto.nome === "Peito de Frango") {
                        imageURL = "./images/chicken_orange.svg"
                      } else if (item?.itemCompra[0]?.produto?.nome === "Coxa de Frango") {
                        imageURL = "./images/chicken_cut_orange.svg"
                      } else if (item?.itemCompra[0]?.produto?.nome === "Linguiça Salsichão") {
                        imageURL = "./images/sausage_orange.svg"
                      } else if (item?.itemCompra[0]?.produto?.nome === "Batata Frita") {
                        imageURL = "./images/fries_orange.svg"
                      }
                      return (
                        <div >
                          <img src={imageURL} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <p>Quantidade: {item.itemCompra[0].quantidadeTotal}Kg</p>
                            <p>Valor: {item.itemCompra[0].valorTotal}</p>
                          </div>
                        </div>
                      )
                    })

                    }
                  </MainRoundContainer>
                </RoundContainer>
              )
            })

            }
          </Tab>
          <Tab eventKey="entregue" title="Entregue">
            {!loading && reportWeeklyMarket?.purchasesDone?.length === 0 ? (
              <RoundContainer style={{ justifyContent: 'center' }}>
                <p style={{ fontSize: 20, fontWeight: 'bold' }}>Nenhuma compra.</p>
              </RoundContainer>
            ) : null
            }
            {reportWeeklyMarket?.purchasesDone?.map((purchase, index) => {
              return (
                <RoundContainer key={index}>
                  <H2RoundContainer>
                    RODADA {purchase[0]?.rodada?.numero}
                    <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
                  </H2RoundContainer>
                  <ParagraphRoundContainer>
                    Compra de Produtos
                    <div />
                  </ParagraphRoundContainer>
                  <MainRoundContainer>
                    {purchase?.map((item, index) => {
                      let imageURL = null
                      if (item?.itemCompra[0].produto.nome === "Peito de Frango") {
                        imageURL = "./images/chicken_orange.svg"
                      } else if (item?.itemCompra[0]?.produto?.nome === "Coxa de Frango") {
                        imageURL = "./images/chicken_cut_orange.svg"
                      } else if (item?.itemCompra[0]?.produto?.nome === "Linguiça Salsichão") {
                        imageURL = "./images/sausage_orange.svg"
                      } else if (item?.itemCompra[0]?.produto?.nome === "Batata Frita") {
                        imageURL = "./images/fries_orange.svg"
                      }
                      return (
                        <div >
                          <img src={imageURL} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <p>Quantidade: {item.itemCompra[0].quantidadeTotal}Kg</p>
                            <p>Valor: {item.itemCompra[0].valorTotal}</p>
                          </div>
                        </div>
                      )
                    })

                    }
                  </MainRoundContainer>
                </RoundContainer>
              )
            })

            }

          </Tab>
        </Tabs>

        {/* <RoundContainer>
          <H2RoundContainer className="totalsRound">
            TOTAL DE RODADAS
            <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
          </H2RoundContainer>
          <ParagraphRoundContainer>
            Compra de insumos
            <div />
          </ParagraphRoundContainer>
          <MainRoundContainer>
            <div>
              <img src="./images/chicken_l_orange.svg" alt="chicken_l_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img src="./images/chicken_p_orange.svg" alt="chicken_p_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img src="./images/condiment_orange.svg" alt="condiment_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img
                src="./images/carry_bag_orange.svg"
                alt="carry_bag_orange
              "
              />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img src="./images/fries_orange.svg" alt="fries_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img src="./images/box_orange.svg" alt="box_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img src="./images/pig_orange.svg" alt="pig_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
          </MainRoundContainer>
        </RoundContainer> */}
        <ButtonsMap />
      </SizeContainer>
    </Container>
  );
};
export default WeeklyReportPurchases;
